/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV1BorCompaniesCompanyIdPscGet } from '../fn/bor/api-v-1-bor-companies-company-id-psc-get';
import { ApiV1BorCompaniesCompanyIdPscGet$Params } from '../fn/bor/api-v-1-bor-companies-company-id-psc-get';
import { apiV1BorCompaniesCompanyIdPscReportJsonGet } from '../fn/bor/api-v-1-bor-companies-company-id-psc-report-json-get';
import { ApiV1BorCompaniesCompanyIdPscReportJsonGet$Params } from '../fn/bor/api-v-1-bor-companies-company-id-psc-report-json-get';
import { apiV1BorCompaniesCompanyIdPscReportPdfGet } from '../fn/bor/api-v-1-bor-companies-company-id-psc-report-pdf-get';
import { ApiV1BorCompaniesCompanyIdPscReportPdfGet$Params } from '../fn/bor/api-v-1-bor-companies-company-id-psc-report-pdf-get';
import { apiV1BorCompaniesSearchGet } from '../fn/bor/api-v-1-bor-companies-search-get';
import { ApiV1BorCompaniesSearchGet$Params } from '../fn/bor/api-v-1-bor-companies-search-get';
import { apiV1BorContactMessagesPost } from '../fn/bor/api-v-1-bor-contact-messages-post';
import { ApiV1BorContactMessagesPost$Params } from '../fn/bor/api-v-1-bor-contact-messages-post';
import { apiV1BorPscInconsistencyReportsPost } from '../fn/bor/api-v-1-bor-psc-inconsistency-reports-post';
import { ApiV1BorPscInconsistencyReportsPost$Params } from '../fn/bor/api-v-1-bor-psc-inconsistency-reports-post';
import { PscListResponse as ModelsPscListResponse } from '../models/models/psc-list-response';
import { SearchCompanyResponse as ModelsSearchCompanyResponse } from '../models/models/search-company-response';
import { SubmitContactMessageResponse as ModelsSubmitContactMessageResponse } from '../models/models/submit-contact-message-response';
import { SubmitPscInconsistencyReportResponse as ModelsSubmitPscInconsistencyReportResponse } from '../models/models/submit-psc-inconsistency-report-response';
import { BorPscReportResponse as ReportsBorPscReportResponse } from '../models/reports/bor-psc-report-response';

@Injectable({ providedIn: 'root' })
export class BorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV1BorCompaniesSearchGet()` */
  static readonly ApiV1BorCompaniesSearchGetPath = '/api/v1/bor/companies/search';

  /**
   * Search BOR companies.
   *
   * Searches approved companies on the Beneficial Ownership Register.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1BorCompaniesSearchGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesSearchGet$Response(params: ApiV1BorCompaniesSearchGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSearchCompanyResponse>> {
    const obs = apiV1BorCompaniesSearchGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Search BOR companies.
   *
   * Searches approved companies on the Beneficial Ownership Register.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1BorCompaniesSearchGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesSearchGet(params: ApiV1BorCompaniesSearchGet$Params, context?: HttpContext): Observable<ModelsSearchCompanyResponse> {
    const resp = this.apiV1BorCompaniesSearchGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSearchCompanyResponse>): ModelsSearchCompanyResponse => r.body)
    );
  }

  /** Path part for operation `apiV1BorCompaniesCompanyIdPscGet()` */
  static readonly ApiV1BorCompaniesCompanyIdPscGetPath = '/api/v1/bor/companies/{companyId}/psc';

  /**
   * Get company PSC records.
   *
   * Lists persons with significant control for the supplied company ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1BorCompaniesCompanyIdPscGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesCompanyIdPscGet$Response(params: ApiV1BorCompaniesCompanyIdPscGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsPscListResponse>> {
    const obs = apiV1BorCompaniesCompanyIdPscGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get company PSC records.
   *
   * Lists persons with significant control for the supplied company ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1BorCompaniesCompanyIdPscGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesCompanyIdPscGet(params: ApiV1BorCompaniesCompanyIdPscGet$Params, context?: HttpContext): Observable<ModelsPscListResponse> {
    const resp = this.apiV1BorCompaniesCompanyIdPscGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsPscListResponse>): ModelsPscListResponse => r.body)
    );
  }

  /** Path part for operation `apiV1BorCompaniesCompanyIdPscReportJsonGet()` */
  static readonly ApiV1BorCompaniesCompanyIdPscReportJsonGetPath = '/api/v1/bor/companies/{companyId}/psc/report.json';

  /**
   * Get company PSC report JSON.
   *
   * Returns the same report-view data used by the PDF report without image payloads.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1BorCompaniesCompanyIdPscReportJsonGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesCompanyIdPscReportJsonGet$Response(params: ApiV1BorCompaniesCompanyIdPscReportJsonGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportsBorPscReportResponse>> {
    const obs = apiV1BorCompaniesCompanyIdPscReportJsonGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get company PSC report JSON.
   *
   * Returns the same report-view data used by the PDF report without image payloads.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1BorCompaniesCompanyIdPscReportJsonGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesCompanyIdPscReportJsonGet(params: ApiV1BorCompaniesCompanyIdPscReportJsonGet$Params, context?: HttpContext): Observable<ReportsBorPscReportResponse> {
    const resp = this.apiV1BorCompaniesCompanyIdPscReportJsonGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ReportsBorPscReportResponse>): ReportsBorPscReportResponse => r.body)
    );
  }

  /** Path part for operation `apiV1BorCompaniesCompanyIdPscReportPdfGet()` */
  static readonly ApiV1BorCompaniesCompanyIdPscReportPdfGetPath = '/api/v1/bor/companies/{companyId}/psc/report.pdf';

  /**
   * Download company PSC report PDF.
   *
   * Generates a Chromium-rendered PDF report for the supplied company ID.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1BorCompaniesCompanyIdPscReportPdfGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesCompanyIdPscReportPdfGet$Response(params: ApiV1BorCompaniesCompanyIdPscReportPdfGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const obs = apiV1BorCompaniesCompanyIdPscReportPdfGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Download company PSC report PDF.
   *
   * Generates a Chromium-rendered PDF report for the supplied company ID.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1BorCompaniesCompanyIdPscReportPdfGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1BorCompaniesCompanyIdPscReportPdfGet(params: ApiV1BorCompaniesCompanyIdPscReportPdfGet$Params, context?: HttpContext): Observable<Blob> {
    const resp = this.apiV1BorCompaniesCompanyIdPscReportPdfGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiV1BorContactMessagesPost()` */
  static readonly ApiV1BorContactMessagesPostPath = '/api/v1/bor/contact-messages';

  /**
   * Submit contact message.
   *
   * Captures a public contact message for support review.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1BorContactMessagesPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1BorContactMessagesPost$Response(params: ApiV1BorContactMessagesPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSubmitContactMessageResponse>> {
    const obs = apiV1BorContactMessagesPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Submit contact message.
   *
   * Captures a public contact message for support review.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1BorContactMessagesPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1BorContactMessagesPost(params: ApiV1BorContactMessagesPost$Params, context?: HttpContext): Observable<ModelsSubmitContactMessageResponse> {
    const resp = this.apiV1BorContactMessagesPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSubmitContactMessageResponse>): ModelsSubmitContactMessageResponse => r.body)
    );
  }

  /** Path part for operation `apiV1BorPscInconsistencyReportsPost()` */
  static readonly ApiV1BorPscInconsistencyReportsPostPath = '/api/v1/bor/psc/inconsistency-reports';

  /**
   * Submit PSC inconsistency report.
   *
   * Captures a public report of incomplete, unavailable, discrepant, or otherwise inaccurate PSC information for review.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1BorPscInconsistencyReportsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1BorPscInconsistencyReportsPost$Response(params: ApiV1BorPscInconsistencyReportsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsSubmitPscInconsistencyReportResponse>> {
    const obs = apiV1BorPscInconsistencyReportsPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Submit PSC inconsistency report.
   *
   * Captures a public report of incomplete, unavailable, discrepant, or otherwise inaccurate PSC information for review.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV1BorPscInconsistencyReportsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1BorPscInconsistencyReportsPost(params: ApiV1BorPscInconsistencyReportsPost$Params, context?: HttpContext): Observable<ModelsSubmitPscInconsistencyReportResponse> {
    const resp = this.apiV1BorPscInconsistencyReportsPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ModelsSubmitPscInconsistencyReportResponse>): ModelsSubmitPscInconsistencyReportResponse => r.body)
    );
  }

}
